export enum CommunicationTypeEnum {
  News = 'News',
  Announcement = 'Announcement',
  Mail = 'Email',
  Task = 'Task',
  Banner = 'Banner'
}
